import { atom } from 'recoil';

export const audioStreamsState = atom({
	key: 'audioStreamStateKey',
	default: [] as string[],
});
